import { Box, styled } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { SBreadcrumbs, SButton } from '@setvi/shared/components';
import { CheckIconV2 } from '@setvi/shared/components/sicons';
import {
  CatalogConfig,
  Product,
  ProductCategoryBreadcrumb
} from '@setvi/shared/interfaces';
import { distances } from '@setvi/shared/styles';
import { ROUTES } from 'enumsV2';

const Wrapper = styled(Box)({
  height: 56,
  display: 'flex',
  alignItems: 'center',
  background: '#EEF0F2',
  padding: distances.px.base,
  gap: distances.px.base
});

const getBreadcrumbUrl = (
  breadcrumb: ProductCategoryBreadcrumb,
  configOverride?: CatalogConfig
) => {
  if (configOverride) {
    const params = new URLSearchParams(window.location.search);
    params.set('categoryId', breadcrumb?._id);
    return `${window.location.pathname}?${params}`;
  }
  return `${ROUTES.PRODUCTS_LIST_VIEW}&categoryId=${breadcrumb?._id}`;
};

interface FooterProps {
  readOnly: boolean;
  product: Product;
  canSelectProducts: boolean;
  selectedProducts: Product[];
  selectedCategoryId?: string;
  selectionType?: 'none' | 'checkbox' | 'radio';
  configOverride?: CatalogConfig;
  handleProductSelect: (isChecked: boolean, product: Product[]) => void;
}

const findCategoryBySelectedId = (
  categories: Product['categories'],
  selectedCategoryId?: string
) => {
  if (!categories?.length) return null;
  if (!selectedCategoryId) return categories[0];

  return (
    categories.find(cat =>
      cat.breadcrumbs?.some(b => b._id === selectedCategoryId)
    ) || categories[0]
  );
};

export const Footer = ({
  product,
  readOnly,
  canSelectProducts,
  selectedProducts,
  selectedCategoryId,
  selectionType,
  configOverride,
  handleProductSelect
}: FooterProps) => {
  const activeCategory = findCategoryBySelectedId(
    product?.categories,
    selectedCategoryId
  );
  const hasBreadcrumbs = activeCategory?.breadcrumbs?.length > 0;
  const isSelected = !!selectedProducts?.find(i => i?.sku === product?.sku);

  if (!hasBreadcrumbs && !canSelectProducts) return null;

  return (
    <Wrapper justifyContent={hasBreadcrumbs ? 'space-between' : 'flex-end'}>
      {hasBreadcrumbs && (
        <SBreadcrumbs<ProductCategoryBreadcrumb>
          {...(!readOnly && {
            onBreadcrumbClick: breadcrumb =>
              window.open(
                getBreadcrumbUrl(breadcrumb, configOverride),
                '_blank'
              )
          })}
          parseBreadcrumb={breadcrumb => breadcrumb?.name}
          items={activeCategory?.breadcrumbs || []}
          fontWeight={400}
        />
      )}
      {canSelectProducts && !(selectionType === 'radio' && isSelected) && (
        <SButton
          color={isSelected ? 'secondary' : 'primary'}
          startIcon={isSelected ? <CloseIcon /> : <CheckIconV2 />}
          onClick={() => handleProductSelect(!isSelected, [product])}>
          {isSelected ? 'Deselect this Product' : 'Select this Product'}
        </SButton>
      )}
      {/* canSelectProducts && (
        <Box display="flex" alignItems="center" gridGap="8px">
          Select this Product
          <SCheckbox
            checked={!!selectedProducts?.find(i => i?.sku === product?.sku)}
            onChange={(_, isChecked) =>
              handleProductSelect(isChecked, [product])
            }
          />
        </Box>
      ) */}
    </Wrapper>
  );
};
